import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { NgxSpinner, NgxSpinnerService, NgxSpinnerComponent } from 'ngx-spinner';
import { Observable, Subject, takeUntil } from 'rxjs';
import { IShopifyCustomer } from '@app/_shared/_models';
import { CustomerService } from '../../_shared/_services/customer.service';
import { SearchBarComponent } from '../../_shared/_components/search/search-bar.component';
import { RouterLink } from '@angular/router';
import { MatIcon } from '@angular/material/icon';
import { AsyncPipe, TitleCasePipe, CurrencyPipe, DatePipe } from '@angular/common';

@Component({
    selector: 'app-orders',
    templateUrl: './order-list.component.html',
    styleUrls: ['./order-list.component.scss'],
    imports: [NgxSpinnerComponent, SearchBarComponent, RouterLink, MatIcon, AsyncPipe, TitleCasePipe, CurrencyPipe, DatePipe]
})
export class OrderListComponent implements OnInit, OnDestroy {
  private readonly customerService = inject(CustomerService);
  private readonly ngxSpinnerService = inject(NgxSpinnerService);

  public customer$!: Observable<IShopifyCustomer | undefined>;
  public spinner$!: Observable<NgxSpinner>;

  private readonly unsubscribe: Subject<undefined> = new Subject<undefined>();

  public async ngOnInit(): Promise<void> {
    this.spinner$ = this.ngxSpinnerService.spinnerObservable;
    await this.ngxSpinnerService.show();
    this.customer$ = this.customerService.customer$;

    this.customerService.customer$
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(async () => {
        await this.ngxSpinnerService.hide();
      });
  }

  public ngOnDestroy(): void {
    this.unsubscribe.next(undefined);
    this.unsubscribe.complete();
  }

  public openLogin() {
    this.customerService.openLogin();
  }

  public openRegister() {
    this.customerService.openRegister();
  }
}
